module.exports = __webpack_public_path__ + "static/sungrown-drone-8b23d764b6947385b76b60a4815fb151.jpg";